<template>
  <div class="filter-box">
    <h6>{{ $t('exam.examDate') }}</h6>

    <div class="days-filter-box">
      <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastDays(7)">
        {{ $t('patientSearch.lastSevenDays') }}
      </button>

      <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastDays(15)">
        {{ $t('patientSearch.lastFifteenDays') }}
      </button>

      <button class="btn btn-square" type="button" name="button" @click="doFilterExamListLastDays(30)">
        {{ $t('patientSearch.lastThirtyDays') }}
      </button>
    </div>

    <BaseDateFilterNew class="d-inline-block" :internalDates="internalDates" @change-date="setDates"></BaseDateFilterNew>

    <h6>{{ $t('ffsFilter.label') }}</h6>

    <v-select
      class="v-select v-select-themed ffs-filter"
      v-model="internalFfsFilter"
      data-test="vSelectFfsFilter"
      :reduce="x => x.value"
      :options="ffsFilterOptions"
      :clearable="false"
      :searchable="false">
    </v-select>

    <h6>{{ $t('exam.reportStatus') }}</h6>

    <v-select
      class="v-select v-select-themed ffs-filter"
      v-model="internalReportStatusFilter"
      data-test="vSelectReportStatusFilter"
      :reduce="x => x.value"
      :options="reportStatusFilterOptions"
      :clearable="false"
      :searchable="false">
    </v-select>

    <!-- <v-select
      class="v-select form filter"
      v-model="filterSelected"
      data-test="vSelectFilter"
      :reduce="x => x.value"
      :options="filterOptions">
    </v-select> -->

    <!-- <div class="exam-types">
      <h6>{{ $t('patientSearch.examTypes') }}</h6>

      <div class="row">
        <div class="col-6">
          <div class="form-check">
            <BaseSquareCheckBox id="color" :item="'color'" :initialChecked="internalProperties.color" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="color">
              {{ $t('patientSearch.color') }}
            </label>
          </div>
          <div class="form-check">
            <BaseSquareCheckBox id="redfree" :item="'redfree'" :initialChecked="internalProperties.redfree" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="redfree">
              {{ $t('patientSearch.redfree') }}
            </label>
          </div>
          <div class="form-check">
            <BaseSquareCheckBox id="infrared" :item="'infrared'" :initialChecked="internalProperties.infrared" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="infrared">
              {{ $t('patientSearch.infrared') }}
            </label>
          </div>
          <div class="form-check">
            <BaseSquareCheckBox id="segAnterior" :item="'segAnterior'" :initialChecked="internalProperties.segAnterior" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="segAnterior">
              {{ $t('patientSearch.segAnterior') }}
            </label>
          </div>
        </div>

        <div class="col-6">
          <div class="form-check">
            <BaseSquareCheckBox id="panoramic" :item="'panoramic'" :initialChecked="internalProperties.panoramic" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="panoramic">
              {{ $t('imageType.panoramic') }}
            </label>
          </div>
          <div class="form-check">
            <BaseSquareCheckBox id="stereo" :item="'stereo'" :initialChecked="internalProperties.stereo" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="stereo">
              {{ $t('imageType.stereo') }}
            </label>
          </div>
          <div class="form-check">
            <BaseSquareCheckBox id="mcRas" :item="'mcRas'" :initialChecked="internalProperties.mcRas" @checked="doCheck"/>
            <label class="form-check-label no-wrap" for="mcRas">
              EyerMaps
            </label>
          </div>
        </div>
      </div>
    </div> -->

    <button class="btn btn-success" type="button" name="button" data-test="btnFilter" @click="doFilter(true)">{{ $t('applyFilter') }}</button>
    <!-- <button class="btn btn-primary" type="button" name="button" @click="openModalDownload">{{ $t('download') }}</button> -->

    <!-- <teleport to="body">
      <ExamDownloadModal v-if="showModalDownload" @close="showModalDownload = false"></ExamDownloadModal>
    </teleport> -->
  </div>
</template>

<style lang="scss" scoped>
  .days-filter-box {
    display:                       flex;
    justify-content:               flex-start;
    gap:                           10px;
  }

  .ffs-filter {
    width:                         100%;
  }

  .exam-types {
    display:                       flex;
    flex-direction:                column;
    gap:                           15px;
  }

  .filter-box {
    width:                         100%;
    padding:                       40px 20px 20px 20px;
    display:                       flex;
    flex-direction:                column;
    gap:                           15px;

    h6 {
      color:                       var(--Shades-70);
      font-size:                   var(--font-size-12);
      font-weight:                 400;
      line-height:                 normal;
      letter-spacing:              1.8px;
      text-transform:              uppercase;
      text-overflow:               ellipsis;
      overflow:                    hidden;
      margin: 0;
    }

    .form-check {
      margin-bottom:               10px;
    }

    .btn-success {
      color:                       var(--Shades-W);
      font-size:                   var(--font-size-12);
      font-weight:                 700;
      line-height:                 normal;
      letter-spacing:              3.6px;
      text-transform:              uppercase;
      width:                       100%;
      padding:                     15px;
    }
  }
</style>

<script>
import { useExamFilterStore } from '@/store/examFilter';

export default {
  name: 'ExamFilter',
  props: {
    currentProperties: {
      type: Object,
      default: () => ({
        mcRas: false,
        color: false,
        redfree: false,
        infrared: false,
        segAnterior: false,
        panoramic: false,
        stereo: false
      })
    },
    currentDates: {
      type: Object,
      default: () => ({
        startDate: null,
        endDate: null
      })
    }
  },
  data: () => ({
    filterSelected: 'all',
    internalProperties: {},
    internalDates: {
      startDate: null,
      endDate: null
    },
    internalFfsFilter: 'all',
    internalReportStatusFilter: 'all',
  }),
  computed: {
    ffsFilterOptions() {
      return [
        {value: 'all', label: this.$i18n.t('ffsFilter.all')},
        {value: 'ffs', label: this.$i18n.t('ffsFilter.ffs')},
        {value: 'nonFfs', label: this.$i18n.t('ffsFilter.nonFfs')},
      ]
    },
    reportStatusFilterOptions() {
      return [
        {value: 'all', label: this.$i18n.t('report.reportStatus_all')},
        {value: 'complete', label: this.$i18n.t('report.reportStatus_complete')},
        {value: 'inconclusive', label: this.$i18n.t('report.reportStatus_inconclusive')},
        {value: 'stat', label: this.$i18n.t('report.reportStatus_stat')},
        {value: 'pending', label: this.$i18n.t('report.reportStatus_pending')},
      ]
    }
  },
  watch: {
    currentProperties: {
      deep: true,
      handler(newValue) {
        this.internalProperties = { ...newValue };
      }
    },
    currentDates: {
      deep: true,
      handler(newValue) {
        this.internalDates = { ...newValue };
      }
    }
  },
  mounted() {
    this.internalProperties = { ...this.currentProperties }
    this.internalDates = { ...this.currentDates }
    this.internalFfsFilter = useExamFilterStore().filter.filter.ffsFilter || 'all'
    this.internalReportStatusFilter = useExamFilterStore().filter.filter.reportStatusFilter || 'all'

    // if (this.$route.query.data) {
    //   let data = this.$utils.parseDataQuery(this.$route.query.data)
    //
    //   if (data.startDate) {
    //     this.internalDates.startDate = data.startDate
    //   }
    //   if (data.endDate) {
    //     this.internalDates.endDate = data.endDate
    //   }
    //
    //   if (data.properties) {
    //     Object.keys(data.properties).forEach(key => {
    //       if (this.internalProperties.hasOwnProperty(key)) {
    //         this.internalProperties[key] = data.properties[key]
    //       }
    //     })
    //   }
    //   // this.debounce()
    // }
  },
  methods: {
    setDates(val) {
      this.internalDates.startDate = val.startDate
      this.internalDates.endDate = val.endDate

      if (this.$route.query.data) {
        let data = this.$utils.parseDataQuery(this.$route.query.data)
        if (data.filterSelected) {
          this.filterOptions = data.filterSelected
        }
        // this.debounce()
      }
    },
    debounce: _.debounce(function() {
      this.doFilter(false)
    }, 250, { 'maxWait': 100 }),
    doFilter(newRequest) {
      const examFilterStore = useExamFilterStore()

      let innerFilter = {
        startDate: this.internalDates.startDate,
        endDate: this.internalDates.endDate,
        userOffset: new Date().getTimezoneOffset(),
        patientID: examFilterStore.filter.filter.patientID ?? null,
        ffsFilter: this.internalFfsFilter,
        reportStatusFilter: this.internalReportStatusFilter,
        properties: { ...this.internalProperties }
      };

      let filter = {
        newRequest: newRequest,
        examCurrentPage: newRequest ? 1 : (examFilterStore.filter.examCurrentPage || 0),
        filter: innerFilter
      };

      if (newRequest && !innerFilter.patientID) {
        examFilterStore.reset()

        if (this.internalDates.startDate)
          filter.startDate = this.internalDates.startDate

        if (this.internalDates.endDate)
          filter.endDate = this.internalDates.endDate
      }

      examFilterStore.refreshFilter(filter)

      if (newRequest)
        this.$emit('close');
    },
    doCheck(item) {
      if (this.internalProperties.hasOwnProperty(item.value)) {
        this.internalProperties[item.value] = item.checked;
        // this.debounce()
      }
    },
    doFilterExamListByEyerMaps() {
      this.updateExamFilter({ eyerMaps: true });
    },
    doFilterExamListLastDays(days) {
      const startDate = moment().subtract(days, 'days').toDate();
      const endDate = moment().toDate();

      this.internalDates.startDate = this.$utils.formatDate(this, startDate);
      this.internalDates.endDate = this.$utils.formatDate(this, endDate);

      // this.doFilter(true);
    },
  },
  // unmounted() {
  //   this.filterSelected = 'all'
  //   this.filterDates = undefined
  // },
}
</script>
